/* eslint-disable */

/* ============
 * English Language File
 * ============
 */

export default {
  CONTENT: require('./content.json'),
  ERRORS: require("./errors.json"),
  NOTIFY: require('./notify.json'),
};
